import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const TUTORIALS_ENABLED = true;

/** Tutorials are intentionally desktop-only. Mobile visits do not consume them. */
export function useTutorialsEnabled() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  return TUTORIALS_ENABLED && isDesktop;
}
